module["exports"] = ["#{address.street_name} #{address.building_number}"];